import React from "react";
import { styled } from "styled-components";

export default function HomeHeading({ style, children }) {
  const heading = String(children).split(" ");
  return (
    <Container>
      {heading.map((item, index) => (
        <h2 className="heading" key={index} style={style}>
          {item}
        </h2>
      ))}
    </Container>
  );
}

const Container = styled.div`
  margin-right: auto;
  display: flex;
  flex-wrap: wrap;

  h2.heading {
    display: inline-block;
    text-align: left;
    font-size: 78px;
    font-weight: 500;
    line-height: 1.7em;
    font-style: normal;
    color: #fff;
    font-family: "Space Mono", monospace;
    margin-right: 25px;
    user-select: none;

    &:last-of-type {
      margin-right: 0;
    }
  }

  @media (max-width: 768px) {
    h2.heading {
      font-size: 36px;
      margin-right: 14px;
    }
  }
`;
